import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography, { TypographyProps } from 'src/app/atoms/Typography/Typography';
import { SpacingAndSizePropKeys, SpacingPropKeys } from 'src/app/styles/spacing';

export interface HeadingAndSupportingTextProps {
  heading: TypographyProps;
  supportingText?: TypographyProps;
  subHeading?: TypographyProps;
  gap?: SpacingPropKeys;
  gapSm?: SpacingPropKeys;
  subHeadingGap?: SpacingPropKeys;
  maxWidth?: SpacingAndSizePropKeys;
}

const HeadingAndSupportingText = ({
  heading,
  supportingText,
  subHeading,
  subHeadingGap,
  maxWidth,
  gap = 'spacing-3xl',
  gapSm,
}: HeadingAndSupportingTextProps): JSX.Element => (
  <Stack
    direction='column'
    gap={subHeading ? subHeadingGap : 'spacing-none'}
    maxWidth={maxWidth}
    dataCy='heading-and-supporting-text-container'
  >
    {subHeading && (
      <Typography
        color='text-brand-secondary'
        {...subHeading}
      />
    )}
    <Stack
      direction='column'
      gap={gap}
      gapSm={gapSm}
      dataCy='heading-and-supporting-text-content'
    >
      <Typography {...heading} />
      {supportingText && (
        <Typography
          color='text-tertiary'
          {...supportingText}
        />
      )}
    </Stack>
  </Stack>
);

export default HeadingAndSupportingText;
